// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		showSuggestionProductPrice: true,
	}
};

(function () {  
	BoostPFS.inject(this);  

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
			 if (!suggestionElement) suggestionElement = this.$uiMenuElement;   
		if (!searchElement) searchElement = this.$element;  
		if (!searchBoxId) searchBoxId = this.id; 
	};

	BoostPFS.prototype.beforeBuildSearchBox = function (id) {

		// Remove theme's instant search events
		var cloneSearchBar = jQ(id).clone();
		jQ(id).replaceWith(cloneSearchBar);      
		
		
		if (Utils.InstantSearch.isFullWidthMobile()) {
			jQ(id).removeAttr('autofocus');
			if (jQ(id).is(':focus')) {
				jQ(id).blur();
			}
		}
	};

	BoostPFS.prototype.afterCloseSuggestionMobile = function(searchBoxId, isCloseSearchBox) {
		// Close theme's search pop up
		if (isCloseSearchBox && window.$ && $.fancybox){
			$.fancybox.close(true);
		}
	};
  
  	/* start-boost-custom */
  	SearchInput.prototype._onTypeSearchBoxEvent = function(event) {
		Globals.currentTerm = event.target.value;
        if(Globals.currentTerm.trim().length <= 0){
          jQ('form[action="/search"]').find('input').val('');
          jQ('form[action="/search"]').submit(false);
        }else{
          jQ('form[action="/search"]').submit(true);
        }
	}
    
    InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
		// If the multi-currency feature is enabled, update the product price
		this.prepareSuggestionProductPriceData();
      
        if(this.data.price_min > 0){
          // Check on sale
          var onSale = this.data.compare_at_price_min > this.data.price_min;
          // Format price
          var price = Utils.formatMoney(this.data.price_min);
          var compareAtPrice = '';
          if (this.data && this.data.compare_at_price_min) {
              compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
              if (Settings.getSettingValue('search.removePriceDecimal')) {
                  price = Utils.removeDecimal(price);
                  compareAtPrice = Utils.removeDecimal(compareAtPrice);
              }
          }

          // Build Price
          var result = '';
          if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
              if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
                  result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
              } else {
                  result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
              }
          }
          return result
              .replace(/{{regularPrice}}/g, price)
              .replace(/{{compareAtPrice}}/g, compareAtPrice);
        }else{
        	return "Contactez votre succursale";
        }
	}
    
    InstantSearchResultItemProduct.prototype.compileTemplate = function() {
		if (this.isShow) {
			var searchTerm = Utils.escape(Globals.currentTerm);
			// Product image
			var imageHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
				imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
				imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
			}
			// Product title
			var productTitle = this.customizeProductTitle();
			productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
          
          	var customTitle = productTitle;
            if(Shopify.locale == 'en'){
              customTitle = Utils.getProductMetafield(this.data, 'data-en_CA' , 'name_en');
            }
          
			// SKU
			var skuHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
				skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
				skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
			}
			// Vendor
			var vendorHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
				vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
				vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
			}
			// Price
			var priceHTML = this.compileSuggestionProductPrice();
			// Open the result item in new tab when selected
			var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';

			return this.getTemplate()
				.replace(/{{id}}/g, this.id)
				.replace(/{{escapedBlockType}}/g, Utils.escape(this.parent.type))
				.replace(/{{url}}/g, this.url)
				.replace(/{{newTabAttribute}}/g, newTabAttr)
				.replace(/{{itemProductImage}}/g, imageHTML)
				.replace(/{{title}}/g, customTitle)
				.replace(/{{escapedTitle}}/g, Utils.escape(customTitle))
				.replace(/{{itemProductSku}}/g, skuHTML)
				.replace(/{{itemProductVendor}}/g, vendorHTML)
				.replace(/{{itemProductPrice}}/, priceHTML)
				.replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
				.replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
				.replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem);
		} else {
			return '';
		}
	}

	InstantSearchResultBlock.prototype.compileTemplate = function() {
		if ((this.status != 'active' || !this.isShow) && !this._isShowDYM()) {
			return '';
		}
		var label;

		switch (this.type) {
			case 'suggestions':
				label = Settings.getSettingValue('label.suggestion.instantSearchSuggestionsLabel')
				break;
			case 'collections':
				label = Settings.getSettingValue('label.suggestion.instantSearchCollectionsLabel')
				break;
			case 'products':
				label = Settings.getSettingValue('label.suggestion.instantSearchProductsLabel')
				break;
			case 'pages':
				label = Settings.getSettingValue('label.suggestion.instantSearchPagesLabel')
				break;
			default:
				label = this.isAllEmpty ? this.notFoundLabel : this.label;
				break;
		}
		if (!label) label = this.label;

		return this.getTemplate()
			.replace(/{{type}}/g, this.type)
			.replace(/{{label}}/g, label)
			.replace(/{{class.searchSuggestionHeader}}/g, Class.searchSuggestionHeader)
			.replace(/{{class.searchSuggestionGroup}}/g, Class.searchSuggestionGroup)
			.replace(/{{resultItems}}/g, '');
	}
  	/* end-boost-custom */
})();